const HeaderBox = ({ title, subtext }) => {
  return (
    <div className="flex flex-col gap-1">
      <h1 className="lg:text-30 text-[24px] leading-[30px] font-bold text-gray-900 lg:text-[30px] lg:leading-[34px] dark:text-white">
        {title}
      </h1>
      <p className="lg:text-16 dark:text-darkGray text-[14px] leading-[20px] font-normal text-gray-600 lg:text-[16px] lg:leading-[24px]">
        {subtext}
      </p>
    </div>
  );
};

export default HeaderBox;
